/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useEffect,useState,useContext } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import { useExportPatientNotesMutation, usersList, useViewPatientQuery } from "../../features/apiSlice"
import ViewPatientDetails from "./Components/ViewPatientBasicDetails"
import ViewMedicalNoteDetails from "./Components/ViewMedicalNotes"
import ViewMonitorConditionTemplate from "./Components/viewMonitotingTemplate"
import { useDispatch, useSelector } from "react-redux"
import ViewAdministartiveDetails from "./Components/ViewAdministrativeNotes"
import ViewPatientDevices from "./Components/ViewPatientDevices"
import { Link, useNavigate, useParams } from "react-router-dom"
import {useGetHelpGuidePatientQuery} from '../../features/patientSlice'
import HelpGuideModal from "../../components/HelpGuideModal"

export default function ViewPatient(){
    const {isSideBar,setToastErrorMessage,setToastmessage} = useContext(GlobalContext)
    const [patientTabName,setPatientTabName]= useState('patient')
    const {data,isFetching,status}=useViewPatientQuery({refetchOnMountOrArgChange: true})
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [exportLoading,setExportLoading]=useState(false)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [exportNotes]=useExportPatientNotesMutation()
    const { id } = useParams()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const auth=useSelector(state=>state?.auth)
    const {userType} = auth
    const [queryParams, setQueryParams] = useState('')
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [notesCount, setNotesCount]=useState('0')
    // const [queryParams, setQueryParams] = useState(`type=patients-view-details`)
    const { data: helpguidedata ,status: helpguidestatus } = useGetHelpGuidePatientQuery(queryParams, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });


    
    const handleTabChange=(tabName)=>{
        setPatientTabName(tabName)
    }

    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {
        if (queryParams) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParams]);

      async function handleExport(type){
        let patientId=data[0].patient_id
        let noteType=type
        setExportLoading(true)

        let payload ={patientId,dateformat,noteType}
        const exportRes=await exportNotes(payload)
        setExportLoading(false)

        window.open(exportRes?.data.presigned_url)
        
        if(exportRes?.error){
            setToastErrorMessage("Something went wrong")
        }
        else{
            setToastmessage(exportRes?.data?.message)   
        }   
    }
    
    useEffect(() => {
        setIsSafari(/^((?!chrome|firefox|android).)*safari/i.test(navigator.userAgent));
    }, []);

    useEffect(() => {
        if (userType === 'patient-user') {
          setQueryParams('type=patients-view-details');
        } else {
          setQueryParams('type=observers-view-details');
        }
      }, [userType]);

    return(
        <>
            <div id={"patient_main_div"} className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Dashboard"}/>
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching&&status!=="fulfilled"?<CustomOverLay Active text="Loading Patient Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-3 px-6 h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className="flex items-center mb-2.5 px-8  justify-between">
                                    <div className="flex items-center w-max">
                                        <Link to="/dashboard" >
                                            <h1 className="text-sm font-normal text-[#52555D]">Dashboard</h1>
                                        </Link>
                                        <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Details</h1>
                                    </div>
                                    <span onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer'>
                                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                    </span>
                                </div>
                                <div className="flex justify-between items-center pl-[30px] pr-4 sm:pr-6 md:pr-10 flex-wrap gap-2">
                                    <div className="flex items-center relative min-w-0 flex-shrink">
                                        <p className="text-xl font-semibold text-[#000000]">{data[0]?.first_name || ''} {data[0]?.middle_name || ''} {data[0]?.last_name || ''}</p>
                                        <p className="text-sm font-normal text-[#000000] px-2">{data[0]?.patient_id}</p>
                                        {data[0]?.status==='inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                        <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                        }

                                    </div>
                              
                                    <div className={`flex items-center ${patientTabName==="monitoring_conditions" ? 'xl:flex-nowrap flex-wrap' : 'flex-wrap'} w-auto`}>
                                        <button type="button"
                                            id={'contact-history'}
                                            onClick={() => {dispatch(usersList.util.resetApiState()); navigate(`/dashboard/view-details/contact-history/${id}/${data[0]?.patient_id}`, { state: [data[0]?.patient_id, true, id] }) }}
                                            className={`py-2.5 px-4 flex items-center text-sm sm:text-base lg:text-lg font-normal text-[#fff]  ${patientTabName==="monitoring_conditions" ? 'my-1.5 xl:my-0' : ''} 
                                            rounded-[16px] bg-[#972E4C] whitespace-nowrap focus:bg-[#863B50] disabled:bg-[#777C88]`}
                                        >
                                            View Contact History
                                        </button>
                                        {(patientTabName==="medical_notes" && notesCount!==0) &&
                                            <button id="icon-export" disabled={exportLoading}  onClick={() => handleExport("medical-note")}  className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed whitespace-nowrap ml-4">
                                                {exportLoading?
                                                    <div className='flex justify-center items-center'>                       
                                                        <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>                                                        
                                                    </div>
                                            :<img src="/images/download-red.svg" alt="download-icon" />}
                                            </button>
                                        }
                                        {(patientTabName==="administrative_notes" && notesCount!==0 ) &&
                                                <button id="icon-export" disabled={exportLoading}  onClick={() => handleExport("administrative-note")}  className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed whitespace-nowrap ml-4">
                                                    {exportLoading?
                                                        <div className='flex justify-center items-center'>                       
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>                                                        
                                                        </div>
                                                    :<img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                        }
                                        {patientTabName==="monitoring_conditions" &&
                                            <button type="button" 
                                                onClick={()=>{dispatch(usersList.util.resetApiState()); navigate(`/dashboard/monitoring-condition-changes/${id}`, 
                                                { state: [data[0].user_name, true] }
                                            ) }}
                                                className={`py-2.5 px-4 flex items-center text-sm sm:text-base lg:text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] whitespace-nowrap ml-4
                                            focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                View Change History 
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div className='mx-7 mt-1'>
                                    <div className={`flex justify-between ${isSafari? 'pb-4' : 'pb-2'} overflow-x-auto overflow-y-hidden ${isSafari? 'scrollbar_purple' : 'scrollBar-hidden'} border-b border-[#E7CBD2] w-full mr-6`}>
                                        <button onClick={()=>{handleTabChange('patient')}} className={`px-2.5 pt-2.5 min-w-fit text-base font-semibold ${patientTabName==='patient'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='patient'?'patient_tab':''}`}>
                                            Patient Details
                                        </button>
                                        <button id={'monitor_tab'} data-testid={'monitoring_conditions'} onClick={()=>{handleTabChange('monitoring_conditions')}} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='monitoring_conditions'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='monitoring_conditions'?'patient_tab':''}`}>
                                            Monitoring Conditions
                                        </button>
                                        <button id={'device_details'} onClick={()=>{handleTabChange('device_details')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='device_details'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='device_details'?'patient_tab':''}`}>
                                            Device Details
                                        </button>
                                        <button id={'administrative_notesTab'} onClick={()=>{handleTabChange('administrative_notes')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='administrative_notes'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='administrative_notes'?'patient_tab':''}`}>
                                            Administrative Notes
                                        </button>
                                        <button id={'medical_notesTab'} onClick={()=>{handleTabChange('medical_notes')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='medical_notes'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='medical_notes'?'patient_tab':''}`}>
                                            Medical Notes
                                        </button>
                                    </div>
                                </div>
                                {patientTabName==="patient"&& <ViewPatientDetails 
                                    data={data}

                                />}
                                {patientTabName==="monitoring_conditions"&&<ViewMonitorConditionTemplate 
                                    viewDataFromPatient={{"data":data?.[0]?.monitoring_template}}
                                />}
                                {patientTabName==="administrative_notes"&& <ViewAdministartiveDetails
                                    notesCount={notesCount} 
                                    setNotesCount={setNotesCount}
                                />}
                                {patientTabName==="medical_notes"&& <ViewMedicalNoteDetails
                                    notesCount={notesCount} 
                                    setNotesCount={setNotesCount}
                                />}
                                {patientTabName==="device_details"&&<ViewPatientDevices 
                                    patient_id={data?.[0]?.patient_id}
                                />}
                                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                                <HelpGuideModal
                                    setHelpGuideModel={setHelpGuideModel}
                                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                                />
                            }
                            </div>
                            
                        </motion.div>
                    </div>
                   
                                           
                </>}
            </div>
        </>
    )
}